import React from 'react';

import { RedeemDetailsProvider } from './redeem-details';
import { RedeemOffersProvider } from './redeem-offers';
import { RedeemRowsProvider } from './redeem-rows';
import { RedeemSummaryProvider } from './redeem-summary';

interface RedeemProvidersProps {
  children: React.ReactNode;
}

type ProviderComponent<P> = React.ComponentType<P & RedeemProvidersProps>;

const composeProviders = <P,>(
  providers: ProviderComponent<P>[]
): React.FC<P & RedeemProvidersProps> => {
  return function ComposedProviders({ children, ...props }: P & RedeemProvidersProps) {
    return providers.reduceRight<React.ReactNode>(
      (inner, Provider) => <Provider {...(props as P)}>{inner}</Provider>,
      children
    ) as JSX.Element;
  };
};

const providers: ProviderComponent<RedeemProvidersProps>[] = [
  RedeemSummaryProvider,
  RedeemOffersProvider,
  RedeemRowsProvider,
  RedeemDetailsProvider,
];

export const RedeemProviders = composeProviders<RedeemProvidersProps>(providers);
